import Styles from './SelectNumberOfCampaigns.module.scss'
import { SelectNumberOfCampaignsProps } from 'screens/Campaigns/components/BatchCreateCampaignsModal/SelectNumberOfCampaigns/Types'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { CountInput } from 'components/Wizards/CountInput/CountInput'
import { Button } from 'blaze-ui/Button'
import { ArrowRight, LightningFilled } from 'blaze-ui/icons'
import { ModalTitleContainer } from 'screens/Campaigns/components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalTitleContainer'
import { pluralize } from 'utils'
import { useId } from '@react-aria/utils'

export const SelectNumberOfCampaigns = ({ onSubmit, value, onChange }: SelectNumberOfCampaignsProps) => {
  const id = useId()
  return (
    <div className={Styles.wrapper}>
      <ModalTitleContainer>New Campaign</ModalTitleContainer>
      <div className={Styles.newCampaigns}>
        <div className={Styles.description}>
          <div className={Styles.icon}>
            <LightningFilled size={32} color="var(--green-10)" />
          </div>
          <div className={Styles.content}>
            <div className={Styles.header}>
              <Heading level={3}>Blaze will generate campaigns for you</Heading>
              <Text variant="secondary" color="var(--dark-40)">
                Let Blaze create & design multiple pieces of content
              </Text>
            </div>
            <div className={Styles.fieldContainer}>
              <div className={Styles.field} role="group" aria-labelledby={id}>
                <Text variant="secondary" id={id}>
                  Number of campaigns
                </Text>
                <CountInput
                  className={Styles.countInput}
                  flex
                  size="lg"
                  buttonSize="lg"
                  name="numberOfCampaigns"
                  value={value}
                  min={1}
                  max={5}
                  onChange={onChange}
                />
              </div>
              <Button
                endIcon={ArrowRight}
                size="lg"
                onPress={() => onSubmit(value)}
                aria-label={`Create ${pluralize('Campaign', value)}`}
              >
                Create {pluralize('Campaign', value)}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
